import { SubscribePage } from '@/features/subscribe/subscribe-page'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/company/$companyId/subscribe')({
	component: RouteComponent,
})

function RouteComponent() {
	const { companyId } = Route.useParams()
	return <SubscribePage companyId={companyId} />
}
